import styled from 'styled-components';

import MultiCheckbox from '@r1-frontend/ui-react/components/controls/multiCheckbox';
import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import { Paragraph4 } from '@r1-frontend/ui-react/components/typography/paragraph';
import { AdvertisingLabelWithTooltip } from '@r1-frontend/ui-react/organisms/AdvertisingLabelWithTooltip';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

import PopupNoAuth from '~/src/components/Popups/NoAuth';
import PopupResponse from '~/src/components/Popups/PopupResult';

export const AdvertisingLabel = styled(AdvertisingLabelWithTooltip)`
    width: min-content;
`;

export const Wrapper = styled.div`
    row-gap: 48px;
    margin-top: 8px;
    
    & > div {
        row-gap: 16px;
        flex-direction: column;
    }
    
    & #topBlock ${Paragraph4} {
        max-width: 300px;
    }

    @media (min-width: ${wideBreakpoints.mobile}) {
        & button {
          max-width: fit-content;
        }
    }

    @media (max-width: ${wideBreakpoints.mobile}) {
        margin-top: 24px;
        & #topBlock {
            padding: 0 8px;
        }
            
        & #bottomBlock {
            padding: 0 16px;
        }
        
        & ${Paragraph4} {
           ${FONTS.S};
        }
    }
`;

export const SPopupNoAuth = styled(PopupNoAuth)`
    @media (max-width: ${wideBreakpoints.laptop}) {
        z-index: 300;
    }
`;

export const SPopupResponse = styled(PopupResponse)`
    @media (max-width: ${wideBreakpoints.laptop}) {
        z-index: 300;
    }
`;

export const SMultiCheckbox = styled(MultiCheckbox)`
    margin-top: 12px;

    &:nth-child(4), &:nth-child(5) {
        width: 172px;

        input > span {
            width: inherit;
            text-align: center;
        }
    }
`;

export const SMultiCheckboxWrapper = styled.div`
    max-width: 360px;
    margin-top: -12px;
`;
